export default __webpack_public_path__ + "static/media/level-silver.94e944d2.svg";